import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PERMISSIONS, Permission } from '@/shared/models/Permission';

import { CobaltThemeProvider } from '@cae/cobalt-react';
import PrecheckinMFE from './features/PrecheckinMFE';
import { PublicClientApplication } from '@azure/msal-browser';
import { User } from '@/shared/models/user';
import msalMockData from './mocks/data/msalMockData';
import userMockData from './mocks/data/userMockData';

const msalInstance: PublicClientApplication =
  (window as any).props?.msalInstance ?? msalMockData;

const user: User = (window as any).props?.user ?? userMockData;

const permissions: Permission[] =
  (window as any).props?.permissions ?? [{ name: PERMISSIONS.TRAIN_MODULE_VIEW_ANY }];

function App() {
  //const account = msalInstance.getActiveAccount();

  // if (account?.username === 'mock-username') {
  //   return (
  //     <center>
  //       <h2>Hello, {account.name}!</h2>
  //     </center>
  //   );
  // }

  // Wrap with BrowserRouter for standalone development
  // In production, the host app provides the router context
  const HostWrapper: React.FC = () => {
    return (
      <PrecheckinMFE
        msalInstance={msalInstance}
        user={user}
        permissions={permissions}
        onNavigateHome={() => {
          window.location.href = '/';
        }}
        hideSideNavigation={() => {}}
      />
    );
  };

  return (
    <BrowserRouter>
      <CobaltThemeProvider initialBrand="default">
        <Routes>
          <Route path="/checkin/:trainingId/*" element={<HostWrapper />} />
          <Route path="/checkin/*" element={<HostWrapper />} />
          <Route path="/" element={<HostWrapper />} />
        </Routes>
      </CobaltThemeProvider>
    </BrowserRouter>
  );
}

export default App;
